import {
  base_colorSurface,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  .cardIcon-background {
    background-color: ${base_colorSurface};
    border-radius: 12px;
    padding: ${spacing(4)} ${spacing(8)};
  }

  .add-color {
    text-align: center;
    color: ${text_colorTextSecondary};
  }

  .AlertPanel.default {
    color: initial;
  }

  .alert-text {
    color: ${text_colorTextSecondary};
  }
`
